"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var netmd_1 = require("./netmd");
var netmd_interface_1 = require("./netmd-interface");
var utils_1 = require("./utils");
var _1 = require(".");
exports.EncodingName = (_a = {},
    _a[netmd_interface_1.Encoding.sp] = 'sp',
    _a[netmd_interface_1.Encoding.lp2] = 'lp2',
    _a[netmd_interface_1.Encoding.lp4] = 'lp4',
    _a);
exports.ChannelName = (_b = {},
    _b[netmd_interface_1.Channels.mono] = 'mono',
    _b[netmd_interface_1.Channels.stereo] = 'stereo',
    _b);
exports.Flag = (_c = {},
    _c[netmd_interface_1.TrackFlag.protected] = 'protected',
    _c[netmd_interface_1.TrackFlag.unprotected] = 'unprotected',
    _c);
function openPairedDevice(usb, logger) {
    return __awaiter(this, void 0, void 0, function () {
        var devices, netmd;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, usb.getDevices()];
                case 1:
                    devices = _a.sent();
                    if (devices.length === 0) {
                        return [2 /*return*/, null]; // No device found
                    }
                    netmd = new netmd_1.NetMD(devices[0], 0, logger);
                    return [4 /*yield*/, netmd.init()];
                case 2:
                    _a.sent();
                    return [2 /*return*/, new netmd_interface_1.NetMDInterface(netmd, logger)];
            }
        });
    });
}
exports.openPairedDevice = openPairedDevice;
function openNewDevice(usb, logger) {
    return __awaiter(this, void 0, void 0, function () {
        var filters, device, err_1, netmd;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filters = netmd_1.DevicesIds.map(function (_a) {
                        var vendorId = _a.vendorId, deviceId = _a.deviceId;
                        return ({ vendorId: vendorId, deviceId: deviceId });
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, usb.requestDevice({ filters: filters })];
                case 2:
                    device = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    return [2 /*return*/, null]; // No device found or not allowed by the user
                case 4:
                    netmd = new netmd_1.NetMD(device, 0, logger);
                    return [4 /*yield*/, netmd.init()];
                case 5:
                    _a.sent();
                    return [2 /*return*/, new netmd_interface_1.NetMDInterface(netmd, logger)];
            }
        });
    });
}
exports.openNewDevice = openNewDevice;
function listDevice(usb) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var filters, device, id, d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    filters = netmd_1.DevicesIds.map(function (_a) {
                        var vendorId = _a.vendorId, deviceId = _a.deviceId;
                        return ({ vendorId: vendorId, deviceId: deviceId });
                    });
                    return [4 /*yield*/, usb.requestDevice({ filters: filters })];
                case 1:
                    device = _e.sent();
                    id = netmd_1.DevicesIds.find(function (did) {
                        return did.deviceId == device.productId && did.vendorId === device.vendorId;
                    });
                    d = {
                        manufacturerName: (_a = device.manufacturerName, (_a !== null && _a !== void 0 ? _a : 'unknown')),
                        productName: (_b = device.productName, (_b !== null && _b !== void 0 ? _b : 'unknown')),
                        vendorId: device.vendorId,
                        productId: device.productId,
                        name: (_d = (_c = id) === null || _c === void 0 ? void 0 : _c.name, (_d !== null && _d !== void 0 ? _d : 'unknown')),
                    };
                    return [2 /*return*/, d];
            }
        });
    });
}
exports.listDevice = listDevice;
var OperatingStatus = {
    50687: 'ready',
    50037: 'playing',
    50045: 'paused',
    49983: 'fastForward',
    49999: 'rewind',
    65315: 'readingTOC',
    65296: 'noDisc',
    65535: 'discBlank',
};
function getDeviceStatus(mdIface) {
    return __awaiter(this, void 0, void 0, function () {
        var status, playbackStatus2, _a, b1, b2, operatingStatus, position, track, discPresent, state, time;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, mdIface.getStatus()];
                case 1:
                    status = _b.sent();
                    return [4 /*yield*/, mdIface.getPlaybackStatus2()];
                case 2:
                    playbackStatus2 = _b.sent();
                    _a = __read([playbackStatus2[4], playbackStatus2[5]], 2), b1 = _a[0], b2 = _a[1];
                    operatingStatus = (b1 << 8) | b2;
                    return [4 /*yield*/, mdIface.getPosition()];
                case 3:
                    position = _b.sent();
                    track = position ? position[0] : null;
                    discPresent = status[4] === 0x40;
                    state = operatingStatus in OperatingStatus ? OperatingStatus[operatingStatus] : 'unknown';
                    if (state === 'playing' && !discPresent) {
                        state = 'ready';
                    }
                    time = position
                        ? {
                            minute: position[2],
                            second: position[3],
                            frame: position[4],
                        }
                        : null;
                    return [2 /*return*/, {
                            discPresent: discPresent && !['readingTOC', 'noDisc'].includes(state),
                            state: state,
                            track: track,
                            time: time,
                        }];
            }
        });
    });
}
exports.getDeviceStatus = getDeviceStatus;
function countTracksInDisc(disc) {
    return disc.groups.reduce(function (acc, g, _) {
        return acc + g.tracks.length;
    }, 0);
}
exports.countTracksInDisc = countTracksInDisc;
function getTracks(disc) {
    var e_1, _a, e_2, _b;
    var tracks = [];
    try {
        for (var _c = __values(disc.groups), _d = _c.next(); !_d.done; _d = _c.next()) {
            var group = _d.value;
            try {
                for (var _e = (e_2 = void 0, __values(group.tracks)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var track = _f.value;
                    tracks.push(track);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return tracks;
}
exports.getTracks = getTracks;
function listContent(mdIface) {
    return __awaiter(this, void 0, void 0, function () {
        var flags, title, fullWidthTitle, _a, discUsed, discTotal, discLeft, trackCount, disc, trackGroupList, _b, _c, _d, groupIndex, _e, groupName, fullWidthName, trackLists, g, tracks, _f, _g, _h, trackIndex, track, title_1, fullWidthTitle_1, _j, codec, channel, duration, _k, flags_1, t, e_3_1, e_4_1;
        var e_4, _l, e_3, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0: return [4 /*yield*/, mdIface.getDiscFlags()];
                case 1:
                    flags = _o.sent();
                    return [4 /*yield*/, mdIface.getDiscTitle()];
                case 2:
                    title = _o.sent();
                    return [4 /*yield*/, mdIface.getDiscTitle(true)];
                case 3:
                    fullWidthTitle = _o.sent();
                    return [4 /*yield*/, mdIface.getDiscCapacity()];
                case 4:
                    _a = __read.apply(void 0, [_o.sent(), 3]), discUsed = _a[0], discTotal = _a[1], discLeft = _a[2];
                    return [4 /*yield*/, mdIface.getTrackCount()];
                case 5:
                    trackCount = _o.sent();
                    disc = {
                        title: title,
                        fullWidthTitle: fullWidthTitle,
                        writable: !!(flags & netmd_interface_1.DiscFlag.writable),
                        writeProtected: !!(flags & netmd_interface_1.DiscFlag.writeProtected),
                        used: utils_1.timeToFrames(discUsed),
                        left: utils_1.timeToFrames(discLeft),
                        total: utils_1.timeToFrames(discTotal),
                        trackCount: trackCount,
                        groups: [],
                    };
                    return [4 /*yield*/, mdIface.getTrackGroupList()];
                case 6:
                    trackGroupList = _o.sent();
                    _o.label = 7;
                case 7:
                    _o.trys.push([7, 23, 24, 25]);
                    _b = __values(trackGroupList.entries()), _c = _b.next();
                    _o.label = 8;
                case 8:
                    if (!!_c.done) return [3 /*break*/, 22];
                    _d = __read(_c.value, 2), groupIndex = _d[0], _e = __read(_d[1], 3), groupName = _e[0], fullWidthName = _e[1], trackLists = _e[2];
                    g = {
                        index: groupIndex,
                        title: groupName,
                        fullWidthTitle: fullWidthName,
                        tracks: [],
                    };
                    disc.groups.push(g);
                    tracks = [];
                    _o.label = 9;
                case 9:
                    _o.trys.push([9, 18, 19, 20]);
                    _f = (e_3 = void 0, __values(trackLists.entries())), _g = _f.next();
                    _o.label = 10;
                case 10:
                    if (!!_g.done) return [3 /*break*/, 17];
                    _h = __read(_g.value, 2), trackIndex = _h[0], track = _h[1];
                    return [4 /*yield*/, mdIface.getTrackTitle(track)];
                case 11:
                    title_1 = _o.sent();
                    return [4 /*yield*/, mdIface.getTrackTitle(track, true)];
                case 12:
                    fullWidthTitle_1 = _o.sent();
                    return [4 /*yield*/, mdIface.getTrackEncoding(track)];
                case 13:
                    _j = __read.apply(void 0, [_o.sent(), 2]), codec = _j[0], channel = _j[1];
                    _k = utils_1.timeToFrames;
                    return [4 /*yield*/, mdIface.getTrackLength(track)];
                case 14:
                    duration = _k.apply(void 0, [_o.sent()]);
                    return [4 /*yield*/, mdIface.getTrackFlags(track)];
                case 15:
                    flags_1 = _o.sent();
                    t = {
                        index: track,
                        title: title_1,
                        fullWidthTitle: fullWidthTitle_1,
                        duration: duration,
                        channel: channel,
                        encoding: codec,
                        protected: flags_1,
                    };
                    tracks.push(t);
                    _o.label = 16;
                case 16:
                    _g = _f.next();
                    return [3 /*break*/, 10];
                case 17: return [3 /*break*/, 20];
                case 18:
                    e_3_1 = _o.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 20];
                case 19:
                    try {
                        if (_g && !_g.done && (_m = _f.return)) _m.call(_f);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 20:
                    g.tracks = g.tracks.concat(tracks);
                    _o.label = 21;
                case 21:
                    _c = _b.next();
                    return [3 /*break*/, 8];
                case 22: return [3 /*break*/, 25];
                case 23:
                    e_4_1 = _o.sent();
                    e_4 = { error: e_4_1 };
                    return [3 /*break*/, 25];
                case 24:
                    try {
                        if (_c && !_c.done && (_l = _b.return)) _l.call(_b);
                    }
                    finally { if (e_4) throw e_4.error; }
                    return [7 /*endfinally*/];
                case 25: return [2 /*return*/, disc];
            }
        });
    });
}
exports.listContent = listContent;
var fixLength = function (len) { return Math.ceil(len / 7); };
function getCellsForTitle(trk) {
    var _a, _b, _c;
    // Sometimes 'LP: ' is added to track names even if the title is '' (+1 cell)
    return Math.max(1, fixLength((_b = (_a = trk.fullWidthTitle) === null || _a === void 0 ? void 0 : _a.length, (_b !== null && _b !== void 0 ? _b : 0)) * 2)) + Math.max(1, fixLength(utils_1.getHalfWidthTitleLength((_c = trk.title, (_c !== null && _c !== void 0 ? _c : '')))));
}
exports.getCellsForTitle = getCellsForTitle;
function getRemainingCharactersForTitles(disc, includeGroups) {
    var e_5, _a, e_6, _b;
    var cellLimit = 255;
    // see https://www.minidisc.org/md_toc.html
    var groups = disc.groups.filter(function (n) { return n.title !== null; });
    // Assume worst-case scenario
    var fwTitle = disc.fullWidthTitle + "0;//";
    var hwTitle = disc.title + "0;//";
    if (includeGroups || includeGroups === undefined)
        try {
            for (var groups_1 = __values(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                var group = groups_1_1.value;
                var range = "" + (group.tracks[0].index + 1) + (group.tracks.length - 1 !== 0 &&
                    "-" + (group.tracks[group.tracks.length - 1].index + 1)) + "//";
                // The order of these characters doesn't matter. It's for length only
                fwTitle += group.fullWidthTitle + range;
                hwTitle += group.title + range;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (groups_1_1 && !groups_1_1.done && (_a = groups_1.return)) _a.call(groups_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
    var usedCells = 0;
    usedCells += fixLength(fwTitle.length * 2);
    usedCells += fixLength(utils_1.getHalfWidthTitleLength(hwTitle));
    try {
        for (var _c = __values(getTracks(disc)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var trk = _d.value;
            usedCells += getCellsForTitle(trk);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_6) throw e_6.error; }
    }
    return Math.max(cellLimit - usedCells, 0) * 7;
}
exports.getRemainingCharactersForTitles = getRemainingCharactersForTitles;
function compileDiscTitles(disc) {
    var e_7, _a;
    var _b;
    var availableCharactersForTitle = getRemainingCharactersForTitles(__assign(__assign({}, disc), { title: '', fullWidthTitle: '' }), false);
    // If the disc or any of the groups, or any track has a full-width title, provide support for them
    var useFullWidth = disc.fullWidthTitle ||
        disc.groups.filter(function (n) { return !!n.fullWidthTitle; }).length > 0 ||
        disc.groups
            .map(function (n) { return n.tracks; })
            .reduce(function (a, b) { return a.concat(b); }, [])
            .filter(function (n) { return !!n.fullWidthTitle; }).length > 0;
    var newRawTitle = '', newRawFullWidthTitle = '';
    if (disc.title)
        newRawTitle = "0;" + disc.title + "//";
    if (useFullWidth)
        newRawFullWidthTitle = "\uFF10\uFF1B" + disc.fullWidthTitle + "\uFF0F\uFF0F";
    try {
        for (var _c = __values(disc.groups), _d = _c.next(); !_d.done; _d = _c.next()) {
            var n = _d.value;
            if (n.title === null || n.tracks.length === 0)
                continue;
            var range = "" + (n.tracks[0].index + 1);
            if (n.tracks.length !== 1) {
                // Special case
                range += "-" + (n.tracks[0].index + n.tracks.length);
            }
            var newRawTitleAfterGroup = newRawTitle + (range + ";" + n.title + "//"), newRawFullWidthTitleAfterGroup = newRawFullWidthTitle + utils_1.halfWidthToFullWidthRange(range) + ("\uFF1B" + (_b = n.fullWidthTitle, (_b !== null && _b !== void 0 ? _b : '')) + "\uFF0F\uFF0F");
            var titlesLengthInTOC_1 = fixLength(utils_1.getHalfWidthTitleLength(newRawTitleAfterGroup)) * 7;
            if (useFullWidth)
                titlesLengthInTOC_1 += fixLength(newRawFullWidthTitleAfterGroup.length * 2) * 7;
            if (availableCharactersForTitle - titlesLengthInTOC_1 < 0)
                break;
            newRawTitle = newRawTitleAfterGroup;
            newRawFullWidthTitle = newRawFullWidthTitleAfterGroup;
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_7) throw e_7.error; }
    }
    var titlesLengthInTOC = fixLength(utils_1.getHalfWidthTitleLength(newRawTitle)) * 7;
    if (useFullWidth)
        titlesLengthInTOC += fixLength(newRawFullWidthTitle.length * 2); // If this check fails the titles without the groups already take too much space, don't change anything
    if (availableCharactersForTitle - titlesLengthInTOC < 0) {
        return null;
    }
    return {
        newRawTitle: newRawTitle,
        newRawFullWidthTitle: useFullWidth ? newRawFullWidthTitle : '',
    };
}
exports.compileDiscTitles = compileDiscTitles;
function rewriteDiscGroups(mdIface, disc) {
    return __awaiter(this, void 0, void 0, function () {
        var compiled, newRawTitle, newRawFullWidthTitle;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    compiled = compileDiscTitles(disc);
                    if (!compiled)
                        return [2 /*return*/];
                    newRawTitle = compiled.newRawTitle, newRawFullWidthTitle = compiled.newRawFullWidthTitle;
                    return [4 /*yield*/, mdIface.setDiscTitle(newRawTitle)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, mdIface.setDiscTitle(newRawFullWidthTitle, true)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.rewriteDiscGroups = rewriteDiscGroups;
function renameDisc(mdIface, newName, newFullWidthName) {
    return __awaiter(this, void 0, void 0, function () {
        var oldName, oldFullWidthName, oldRawName, oldRawFullWidthName, hasGroups, hasFullWidthGroups, hasGroupsAndTitle, hasFullWidthGroupsAndTitle, newFullWidthNameWithGroups, newNameWithGroups;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newName = utils_1.sanitizeHalfWidthTitle(newName);
                    newFullWidthName = newFullWidthName !== undefined ? utils_1.sanitizeFullWidthTitle(newFullWidthName) : undefined;
                    return [4 /*yield*/, mdIface.getDiscTitle()];
                case 1:
                    oldName = _a.sent();
                    return [4 /*yield*/, mdIface.getDiscTitle(true)];
                case 2:
                    oldFullWidthName = _a.sent();
                    return [4 /*yield*/, mdIface._getDiscTitle()];
                case 3:
                    oldRawName = _a.sent();
                    return [4 /*yield*/, mdIface._getDiscTitle(true)];
                case 4:
                    oldRawFullWidthName = _a.sent();
                    hasGroups = oldRawName.indexOf('//') >= 0;
                    hasFullWidthGroups = oldRawName.indexOf('／／') >= 0;
                    hasGroupsAndTitle = oldRawName.startsWith('0;');
                    hasFullWidthGroupsAndTitle = oldRawName.startsWith('０；');
                    if (!(newFullWidthName !== oldFullWidthName && newFullWidthName !== undefined)) return [3 /*break*/, 6];
                    newFullWidthNameWithGroups = void 0;
                    if (hasFullWidthGroups) {
                        if (hasFullWidthGroupsAndTitle) {
                            newFullWidthNameWithGroups = oldRawFullWidthName.replace(/^０；.*?／／/, newFullWidthName !== '' ? "\uFF10\uFF1B" + newFullWidthName + "\uFF0F\uFF0F" : "");
                        }
                        else {
                            newFullWidthNameWithGroups = "\uFF10\uFF1B" + newFullWidthName + "\uFF0F\uFF0F" + oldRawFullWidthName; // Add the new title
                        }
                    }
                    else {
                        newFullWidthNameWithGroups = newFullWidthName;
                    }
                    return [4 /*yield*/, mdIface.setDiscTitle(newFullWidthNameWithGroups, true)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    if (newName === oldName) {
                        return [2 /*return*/];
                    }
                    if (hasGroups) {
                        if (hasGroupsAndTitle) {
                            newNameWithGroups = oldRawName.replace(/^0;.*?\/\//, newName !== '' ? "0;" + newName + "//" : ""); // Replace or delete the old title
                        }
                        else {
                            newNameWithGroups = "0;" + newName + "//" + oldRawName; // Add the new title
                        }
                    }
                    else {
                        newNameWithGroups = newName;
                    }
                    return [4 /*yield*/, mdIface.setDiscTitle(newNameWithGroups)];
                case 7:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.renameDisc = renameDisc;
function upload(mdIface, track, progressCallback) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, format, frames, result, header, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, mdIface.saveTrackToArray(track, function (l, r) {
                        progressCallback && progressCallback({ totalBytes: l, readBytes: r });
                    })];
                case 1:
                    _a = __read.apply(void 0, [_d.sent(), 3]), format = _a[0], frames = _a[1], result = _a[2];
                    _b = format;
                    switch (_b) {
                        case _1.DiscFormat.spStereo: return [3 /*break*/, 2];
                        case _1.DiscFormat.spMono: return [3 /*break*/, 2];
                        case _1.DiscFormat.lp2: return [3 /*break*/, 4];
                        case _1.DiscFormat.lp4: return [3 /*break*/, 4];
                    }
                    return [3 /*break*/, 5];
                case 2:
                    _c = utils_1.createAeaHeader;
                    return [4 /*yield*/, mdIface.getTrackTitle(track)];
                case 3:
                    header = _c.apply(void 0, [_d.sent(), format === _1.DiscFormat.spStereo ? 2 : 1, frames]);
                    return [3 /*break*/, 5];
                case 4:
                    header = utils_1.createWavHeader(format, result.length);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, [format, utils_1.concatUint8Arrays(header, result)]];
            }
        });
    });
}
exports.upload = upload;
function download(mdIface, track, progressCallback) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, err_2, err_3, session, _c, trk, uuid, ccid;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = (_a = ['ready', 'discBlank']).includes;
                    return [4 /*yield*/, getDeviceStatus(mdIface)];
                case 1:
                    if (!!_b.apply(_a, [(_d.sent()).state])) return [3 /*break*/, 3];
                    return [4 /*yield*/, utils_1.sleep(200)];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 0];
                case 3:
                    _d.trys.push([3, 6, , 7]);
                    return [4 /*yield*/, mdIface.sessionKeyForget()];
                case 4:
                    _d.sent();
                    return [4 /*yield*/, mdIface.leaveSecureSession()];
                case 5:
                    _d.sent();
                    return [3 /*break*/, 7];
                case 6:
                    err_2 = _d.sent();
                    return [3 /*break*/, 7];
                case 7: return [4 /*yield*/, mdIface.acquire()];
                case 8:
                    _d.sent();
                    _d.label = 9;
                case 9:
                    _d.trys.push([9, 11, , 12]);
                    return [4 /*yield*/, mdIface.disableNewTrackProtection(1)];
                case 10:
                    _d.sent();
                    return [3 /*break*/, 12];
                case 11:
                    err_3 = _d.sent();
                    return [3 /*break*/, 12];
                case 12:
                    session = new netmd_interface_1.MDSession(mdIface, new netmd_interface_1.EKBOpenSource());
                    return [4 /*yield*/, session.init()];
                case 13:
                    _d.sent();
                    return [4 /*yield*/, session.downloadTrack(track, progressCallback)];
                case 14:
                    _c = __read.apply(void 0, [_d.sent(), 3]), trk = _c[0], uuid = _c[1], ccid = _c[2];
                    return [4 /*yield*/, session.close()];
                case 15:
                    _d.sent();
                    return [4 /*yield*/, mdIface.release()];
                case 16:
                    _d.sent();
                    return [2 /*return*/, [trk, uuid, ccid]];
            }
        });
    });
}
exports.download = download;
//# sourceMappingURL=netmd-commands.js.map